import React, { Component } from "react";

// Styles
import "./Popup.scss";

// Components
// import Button from 'components/Button'

// Icons
import AlertIcon from 'static/icons/alert-icon.svg'

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    const {
      icon = AlertIcon,
      title = 'Please be alerted',
      subTitle = 'The system is clearly stating som alert worthy situation here, please can you be alerted?',
      showCancelButton = false,
      showSuccessButton = false,
      successButton, //this is the html for success button
      cancelButton, //this is the html for cancel button
      onClose
    } = this.props
    return (
      <div className="popup">
        <div>
          <div className="popup-main-container" onClick={(e) => e.stopPropagation()}>
            <div className="popup-main-container__header">
              <div className="close-icon" onClick={onClose}>
                x
            </div>
            </div>
            <div className="popup-main-container__content">
              <img src={icon} alt="Alert icon" />
              <p className="popup-main-container__content--title">
                {title}
              </p>
              <p className="popup-main-container__content--sub-title">
                {subTitle}
              </p>
              <div className="popup-main-container__actions">
                {showSuccessButton
                  &&
                  <>
                    {successButton}
                  </>
                }
                {showCancelButton
                  &&
                  <>
                    {cancelButton}
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Popup;
